import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

// Gate routes by permission. Pass either `any` (array — match any) or
// `all` (array — must match all). Admin always passes via hasPermission.
export default function PermGuard({ any, all }) {
  const { hasPermission, hasAnyPermission, role } = useAuth();
  if (!role) return <Navigate to="/" replace />;

  if (Array.isArray(all) && !all.every((p) => hasPermission(p))) {
    return <Navigate to="/" replace />;
  }
  if (Array.isArray(any) && !hasAnyPermission(...any)) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
